<template>
  <simple-wrapper :full-height="fullHeight" class="bg-light-grey">
    <template #header>
      <div class="flex items-center justify-between p-3 bg-white">
        <div class="text-lg font-bold">{{ title || "OTP" }}</div>
        <svg class="cursor-pointer" fill="none" height="24" viewBox="0 0 24 24" width="24"
             xmlns="http://www.w3.org/2000/svg"
             @click="onClose">
          <g clip-path="url(#clip0_17883_2040)">
            <rect fill="white" height="24" width="24"/>
            <path
                d="M19.1465 6.25L13.8965 11.5L19.1465 16.75L17.749 18.1465L12.499 12.8965L12.3223 13.0732L7.24902 18.1455L5.85352 16.75L11.1035 11.5L5.85352 6.25L7.24902 4.85352L12.499 10.1035L12.6758 9.92676L17.749 4.85254L19.1465 6.25Z"
                fill="#0C070F" stroke="white" stroke-width="0.5"/>
          </g>
          <defs>
            <clipPath id="clip0_17883_2040">
              <rect fill="white" height="24" width="24"/>
            </clipPath>
          </defs>
        </svg>
      </div>
    </template>
    <div class="flex h-full flex-col bg-light-grey p-4 relative">
      <div class="flex flex-col gap-2">
        <div class="font-bold text-3xl">{{ $t('verify.enter_the_code') }}</div>
        <slot name="description">
          <div class="mb-6 text-[#2E2E2EB2]">
            <i18n-t keypath="verify.we_have_send_code_to">
              <template #number>
                <span class="font-medium" dir="ltr">{{ number }}</span>
              </template>
            </i18n-t>
          </div>
        </slot>
      </div>

      <van-form class="w-full h-full flex flex-col items-center" @submit="emit('verify')">
        <div class="w-full">
          <new-otp-input ref="otpInputRef" v-model="code" :error="otpError" :loading="loading"
                         @submit="emit('verify')"></new-otp-input>
        </div>
        <div class="my-3 w-full">
          <template v-if="timer">
            <div class="flex items-center gap-1 text-[#2E2E2EB2]">
              <div class="text-center">{{ $t('verify.resend_code_in') }}</div>
              <van-count-down :time="timer" class="font-medium !text-[#2E2E2EB2]" @finish="emit('update:timer', 0)"/>
            </div>
          </template>
          <template v-else>
            <div class="text-brand-blue cursor-pointer" @click="emit('resend')">
              {{ $t('verify.didnt_receive_the_code') }}
            </div>
          </template>
        </div>
      </van-form>

      <van-button :disabled="loading" :loading="loading" class="!min-h-[44px] !font-bold !rounded-lg"
                  native-type="submit" type="primary">
        {{ $t('auth.confirm') }}
      </van-button>
    </div>
  </simple-wrapper>
</template>

<script setup>
import NewOtpInput from "@/components/form/NewOTPInput";

const props = defineProps({
  modelValue: {
    type: [Number, String],
    default: ""
  },
  title: {
    type: String,
    default: ""
  },
  fullHeight: {
    type: Boolean,
    default: true
  },
  loading: {
    type: Boolean,
    default: false
  },
  resendLoading: {
    type: Boolean,
    default: false
  },
  number: {
    type: String,
    default: ""
  },
  timer: {
    type: Number,
    default: 0
  },
  otpError: {
    type: String,
    default: ""
  }
})

const emit = defineEmits(['update:modelValue', 'close', 'verify', 'resend', 'update:timer'])

const code = computed({
  get() {
    return props.modelValue
  },
  set(val) {
    emit('update:modelValue', val)
  }
})
const onClose = () => {
  emit('close')
}

const otpInputRef = ref(null)
const focusOtp = () => {
  otpInputRef.value?.focusInput()
}

// Expose the method to the parent
defineExpose({
  focusOtp
})
</script>

<style>
</style>